// extracted by mini-css-extract-plugin
export default {"blueColor":"#4a90e2","messagesNavigation":"_3pRHG53Z_zkSBpocOAD3wY","navHeading":"_1v_WksJmbltnVUYXQh26I5","navMenu":"Uy6rkZh_CqX1F319xPHx-","active":"_27s3UDsuhet2Q64XDHh9g"};